import { render } from "./About.vue?vue&type=template&id=0b1beb6c"
const script = {}
script.render = render

export default script